import { Component, Input } from '@angular/core';

@Component({
  selector: 'ut-tag-btn',
  templateUrl: './tag-btn.component.html',
  standalone: false,
})
export class TagBtnComponent {
  @Input() tag: string;
}
